import {Route, Routes} from 'react-router-dom';
import PayNowOverview from "./PayNowOverview";
import BillingSameAddress from "./billing-info";
import PaymentInfoView from "./payment-info-view";
import PaymentSubmittedView from "./payment-submitted-view";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe, Stripe } from "@stripe/stripe-js";
import React, { useState } from "react";
import { getConfiguration } from "../../shared/configuration/config-settings";

import InvalidRoute from "./invalid-route";
import MobilePaymentView from './mobile-payment-view';
import MobilePaymentProgramView from './mobile-payment-program-view';
import NoPaymentProgramView from './no-payment-program-view';
import ForgetPassword from '../../security/components/forget-password';
import {
  PaymentProgramEnrollmentPage
} from './no-sig-auth-doc/payment-program-enrollment/payment-program-enrollment-page';
import {PaymentApprovalPage} from './no-sig-auth-doc/payment-agreement/payment-approval-page';
import {PhiConsentPage} from './no-sig-auth-doc/phi-consent/phi-consent-page';
import VobWebformDemoView from './vob-webform-demo-view';
import PaymentHubView
  from '@finpay-development/shared-platform/lib/esm/payment-hub/components/payment-hub-view';
import {PaymentSuccessView} from './payment-success-view';
import {ScrollToTop} from '../../shared/components/scroll-to-top';

export const PublicPagesWrapper = () => {

  const config = getConfiguration();
  const getPromise = () => {
    // note - Stripe Elements requires a promise, so initializing to an empty promise
    let promise: Promise<Stripe | null> = new Promise(() => {});
    if (config.stripe_key) {
      promise = loadStripe(config.stripe_key);
    }
    return promise;
  };
  const [promise] = useState(() => getPromise());

  return (
    <>
      <Elements stripe={promise}> 
        {/* Scoped to the guest/public pages for now — to apply scroll reset
            app-wide (authenticated routes too), move this into App.tsx inside
            the <Router> instead. */}
        <ScrollToTop />
        <Routes>
          <Route 
            path={"/webpayment"} 
            element={<PayNowOverview />}   
          />
          <Route
            path={"/webpayment/launch"} 
            element={<PayNowOverview />}
          />  
          <Route
            path={"/webpayment/launch/:token"} 
            element={<PayNowOverview />}
          />
          <Route
              path={'/webpayment/billing-info'}
              element={<BillingSameAddress />}
          />
          <Route
              path={'/webpayment/mobile-payment'}
              element={<MobilePaymentView />}
          />
          <Route
              path={'/webpayment/mobile-payment-program'}
              element={<MobilePaymentProgramView />}
          />
          <Route
              path={'/webpayment/no-payment-programs'}
              element={<NoPaymentProgramView />}
          />
          <Route
              path={"/webpayment/payment-info"}
              element={<PaymentInfoView />}
          />
          <Route
            path={"/mobile/patient/:patientId/ioc/:patientEncounterId/pay"}
            element={<PaymentHubView/>}
          />
          <Route
            path={"/webpayment/payment-submitted"}
            element={<PaymentSubmittedView />}
          />
          <Route
              path={"/webpayment/payment-success"}
              element={<PaymentSuccessView />}
          />
          <Route
            path={"/webpayment/*"}
            element={<InvalidRoute path='/webpayment'/>}
          />
          <Route
            path={"/forgot-password"}
            element={<ForgetPassword showPasswordChange={true}/>}
            />
          <Route
              path={"/payment-program-enrollment/:token"}
              element={<PaymentProgramEnrollmentPage />}
          />
          <Route
              path={"/payment-program-enrollment/*"}
              element={<InvalidRoute path='/payment-program-enrollment'/>}
          />
          <Route
              path={"/payment-agreement/:token"}
              element={<PaymentApprovalPage/>}
          />
          <Route
              path={"/payment-agreement/*"}
              element={<InvalidRoute path='/payment-agreement'/>}
          />
          <Route
              path={"/phi-consent/:token"}
              element={<PhiConsentPage/>}
          />
          <Route
              path={"/phi-consent/*"}
              element={<InvalidRoute path='/phi-consent'/>}
          />
          <Route path="/vob-webform-demo" element={<VobWebformDemoView />} />
        </Routes>
      </Elements>
    </>
  );
};